// @ts-nocheck
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import { StyledTheme } from "@toolkit/Framework/Types/StyledTheme";

export default (breakpoint: BreakpointKey, theme: StyledTheme) => theme.breakpoints.keys.indexOf(breakpoint);
